import { ModalDialog } from '../../../components/modalDialog.tsx';
import { ManualTask } from '../../../types/sharedTypeImpl.ts';
import { ManualTasksTable } from './manualTasksTable.tsx';


interface Props {
    tasks: ManualTask[];
    onClose: () => void;
    onEditTaskClick: (task: ManualTask) => void;
    onCompleteTaskClick: (task: ManualTask) => void;
    onCancelTaskClick: (task: ManualTask) => void;
}

export function ScheduledTasksDialog({
    tasks,
    onClose,
    onEditTaskClick,
    onCompleteTaskClick,
    onCancelTaskClick,
}: Props) {

    return (
        <ModalDialog
            frameStyle={{ width: '900px' }}
            isOpen={true}
            onCancel={onClose}
        >
            <ManualTasksTable
                tasks={tasks}
                showCreatedAt={true}
                showScheduledAt={true}
                showCreatedBy={true}
                showButtons={true}
                onEditTaskClick={onEditTaskClick}
                onCompleteTaskClick={onCompleteTaskClick}
                onCancelTaskClick={onCancelTaskClick}
            />
        </ModalDialog>
    );
}
